import ReactMarkdown from "react-markdown";

export function MarkdownLabel(props: { label: string }) {
  return (
    <ReactMarkdown components={{ p: "span", a: MarkdownLink }}>
      {props.label}
    </ReactMarkdown>
  );
}

// Pass as `components={{ a: MarkdownLink }}` to open markdown links in a new tab
export function MarkdownLink({
  href,
  children,
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a href={href} target="_blank" rel="noreferrer">
      {children}
    </a>
  );
}
